<input
	#numericInput
	type="number"
	class="form-control numeric-input"
	(input)="onInput($any($event))"
	(change)="onChange($any($event))"
/>
<span *ngIf="unit" class="unit">{{ unit }}</span>
<div class="numeric-input-controls">
	<button #decrementButton class="btn btn-primary" type="button" (click)="incrementValue(-1)">
		<g-icon [icon]="icons.faMinus" />
	</button>
	<button #incrementButton class="btn btn-primary" type="button" (click)="incrementValue(1)">
		<g-icon [icon]="icons.faPlus" />
	</button>
</div>
